import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { DiagnosticDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/DiagnosticDisplay';
import { NetworkDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/NetworkDisplay';
import { PowerDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/PowerDisplay';
import { FirmwareDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/FirmwareDisplay';
import { TemperatureDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/TemperatureDisplay';
import { LocationDisplay } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/LocationDisplay';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { DeviceDetailContextProvider } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { Actions } from 'app/agriculture/components/Actions/Actions';
import { useParamsId } from 'app/agriculture/charts/useParamsId';
import { useDeviceIcon } from 'app/agriculture/routes/Devices/useDeviceIcon';
import { routeConfig } from 'app/agriculture/router/routeConfig';
import { DeviceSparkChartContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/DeviceSparkChart/DeviceSparkChartContent';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { DeviceShowOnMapButton } from 'app/agriculture/routes/Devices/DeviceDetails/components/DeviceShowOnMapButton';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { useNavigate } from 'react-router-dom';

export function DeviceMoreDetails() {
    const deviceId = useParamsId();
    const device = useDevice({ deviceId });
    const deviceIcon = useDeviceIcon({ deviceId });
    const navigate = useNavigate();
    const farmPath = useFarmPath();

    const isGatewayOrRelay =
        device.deviceType === 'Yarn Gateway' || device.deviceType === 'Yarn Relay';

    return (
        <DeviceDetailContextProvider deviceId={deviceId}>
            <ContentBox
                className="DeviceMoreDetails"
                title={device.name}
                variant="xl"
                Icon={deviceIcon}
                showOnMapButton={
                    <SuspenseWrapper loadingComponent={null}>
                        <DeviceShowOnMapButton deviceId={device.id} />
                    </SuspenseWrapper>
                }
            >
                <ContentBox.Section scrollable disableDivider>
                    <SimpleGrid columns={3}>
                        <StatDisplay id="device-id" name="Device ID" value={device.externalId} />
                    </SimpleGrid>
                    {!isGatewayOrRelay && <DeviceSparkChartContent />}
                    <DiagnosticDisplay />
                    <NetworkDisplay />
                    <PowerDisplay />
                    <FirmwareDisplay />
                    <TemperatureDisplay />
                    <LocationDisplay />
                    <Actions
                        sticky
                        primaryAction={{
                            text: 'Edit',
                            startIcon: 'edit',
                            onClick: () => {
                                navigate(
                                    farmPath(`/${routeConfig.Device.rootPath}/${deviceId}/edit`),
                                );
                            },
                        }}
                        backAction={{
                            text: 'Back',
                            onClick: () => {
                                navigate(-1);
                            },
                        }}
                    />
                </ContentBox.Section>
            </ContentBox>
        </DeviceDetailContextProvider>
    );
}
